const GET_TITLE = 'GET_TITLE';
const SET_TITLE = 'SET_TITLE';

export {
    GET_TITLE,
    SET_TITLE
};